module.exports = __webpack_public_path__ + "img/remax_balloon.png";